(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["collapsible"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('content-drawer')) {
    customElements.define('content-drawer', class ContentDrawer extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        const title = this.querySelector(':scope > .drawer-title') || this.querySelector('.drawer-title');
        if (title) {
          title.addEventListener('click', () => this.toggleDrawer());
        }

        const questionId = new URLSearchParams(window.location.search).get('question');
        if (questionId && this.dataset.id === questionId) {
          this.toggleDrawer(true);
          setTimeout(() => {
            this.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 500);
        }
      }

      toggleDrawer(state = null) {
        const isOpen = this.getAttribute('data-open') === 'true';
        this.setAttribute('data-open', state ?? !isOpen);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
